import algoliasearch from 'algoliasearch';
import _debounce from 'lodash/debounce';
import qs from 'qs';

import VsPagination from '@vuesimple/vs-pagination';
import SearchResult from '../SearchResult/SearchResult.vue';

const algoliaIndex = window.drupalSettings.algolia.generalIndex;
const algoliaAppId = window.drupalSettings.algolia.appId;
const algoliaAPIKey = window.drupalSettings.algolia.apiKey;

const client = algoliasearch(algoliaAppId, algoliaAPIKey);

export default {
    props: {
        title: {
            type: String,
        },
    },

    components: {
        VsPagination,
        SearchResult
    },

    mounted () {
        this.readUrl();
    },

    data () {
        return {
            showResults:    false,
            hits:           [],
            val:            '',
            index:          client.initIndex(algoliaIndex),
            loading:        false,
            firstKeyStroke: true,
        };
    },

    computed: {

    },

    methods: {
        onSearchInput: _debounce(function () {
            if (this.firstKeyStroke) {
                this.setIndex();
                this.firstKeyStroke = false;
            }
            this.fetchData();
        }, 500),

        fetchData (page = 0) {
            if (this.val.length) {
                this.index.search(this.val, { filters: `field_date_range > ${new Date().getTime() / 1000}`, page }).then(({ hits, nbPages }) => {
                    this.hits = hits;
                    this.showResults = true;
                    this.nbPages = nbPages;
                    this.loading = false;
                });
            }
            else {
                this.hits = [];
            }
        },

        setIndex () {

        },
        onClearClick () {
            this.clear();
        },
        clear () {
            this.val = '';
            this.hits = [];
        },
        highlight (content) {
            if (!this.val) {
                return content;
            }
            return content.replace(new RegExp(this.val, 'gi'), (match) => `<strong>${match}</strong>`);
        },
        readUrl () {
            const urlQuery = window.location.search;
            const queryObject = qs.parse(urlQuery, { ignoreQueryPrefix: true });

            if (queryObject.keys) {
                this.val = queryObject.keys;
                this.setIndex();
                this.fetchData();
            }
        },

        updateUrl (data) {
            this.queryParams = { ...this.queryParams, ...data };
            const queryString = qs.stringify(this.queryParams, { encode: false });

            if (queryString.length) {
                window.history.replaceState({}, '', `${document.location.origin + document.location.pathname}?${queryString}`);
            }
            else {
                window.history.replaceState({}, '', `${document.location.origin + document.location.pathname}`);
            }
        },

        changePage (page) {
            this.fetchData(page - 1);
        },
    },

    watch: {
        val (val) {
            if (val.length && !this.loading) {
                this.loading = true;
            } else if(!val.length) {
                this.loading = false;
            }
            this.updateUrl({ keys: val });
        },
    },
};
